import React from 'react';

const MobileLogo = () => {
    return (
        <a title='pmc oman' className="qodef-mobile-header-logo-link qodef-height--set qodef-source--image" href="/" rel="home">
            <img 
                loading="lazy" 
                width="296" 
                height="68" 
                style={{width:"100px",height:"auto",objectFit:"cover",}}
                src="/img/pmclogo.png" 
                className="qodef-header-logo-image qodef--main" 
                alt="logo pmc oman" 
             
            />
        </a>
    );
};

export default MobileLogo;